module.exports = __webpack_public_path__ + "img/figure-2.216fbd75.png";